const BALANCED_WEIGHT_TOLERANCE = 1e-6

export function isBalancedWeightTotal(totalWeight: number) {
  return Math.abs(totalWeight - 1) <= BALANCED_WEIGHT_TOLERANCE
}

export function sumWeights(weights: (number | null | undefined)[]) {
  return weights.reduce((sum, current) => sum + (current ?? 0), 0)
}
